import React, { useState, useEffect } from "react";
import { Grid, TextField, Typography } from "@material-ui/core";

const LocationInputs = ({ values, setFieldValue }) => {
  const [latInput, setLatInput] = useState(values.location.latitude);
  const [lngInput, setLngInput] = useState(values.location.longitude);

  // Sync inputs when Formik location changes (from map click or search)
  useEffect(() => {
    if (values.location) {
      setLatInput(values.location.latitude ?? "");
      setLngInput(values.location.longitude ?? "");
    }
  }, [values.location]);

  const commitLocation = () => {
    if (latInput === "" || lngInput === "") return;

    const lat = Number(latInput);
    const lng = Number(lngInput);

    if (
      Number.isNaN(lat) ||
      Number.isNaN(lng) ||
      lat < -90 ||
      lat > 90 ||
      lng < -180 ||
      lng > 180
    ) {
      return;
    }

    setFieldValue("location", {
      latitude: lat,
      longitude: lng,
    });
  };

  return (
    <div style={{ marginTop: 18 }}>
      <Typography
        variant="body2"
        style={{ color: "#64748b", marginBottom: 12 }}
      >
        Tambien puedes introducir las coordenadas manualmente. Se guardan al
        salir del campo o al presionar Enter.
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            label="Latitude"
            variant="outlined"
            fullWidth
            value={latInput}
            onChange={(e) => setLatInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && commitLocation()}
            onBlur={commitLocation}
            inputProps={{ step: "any" }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Longitude"
            variant="outlined"
            fullWidth
            value={lngInput}
            onChange={(e) => setLngInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && commitLocation()}
            onBlur={commitLocation}
            inputProps={{ step: "any" }}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default LocationInputs;
